import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const TableSkeleton = ({ rows = 5, columns = 7, showAvatar = true }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      {/* Table Header Skeleton */}
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <SkeletonLoader variant="title" width="200px" />
          <SkeletonLoader variant="default" width="320px" height="40px" />
        </div>
      </div>

      {/* Desktop Table View */}
      <div className="hidden lg:block">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-6 py-4 w-10">
                <SkeletonLoader variant="default" width="20px" height="20px" />
              </th>
              {Array.from({ length: columns }, (_, i) => (
                <th key={i} className="px-6 py-4 text-left">
                  <SkeletonLoader variant="text" width="100px" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {Array.from({ length: rows }, (_, rowIndex) => (
              <tr key={rowIndex} className="hover:bg-muted/30">
                <td className="px-6 py-4">
                  <SkeletonLoader variant="default" width="20px" height="20px" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    {showAvatar && <SkeletonLoader variant="avatar" />}
                    <div className="space-y-2 flex-1">
                      <SkeletonLoader variant="text" width="150px" />
                      <SkeletonLoader variant="text" width="100px" />
                    </div>
                  </div>
                </td>
                {Array.from({ length: columns - 2 }, (_, colIndex) => (
                  <td key={colIndex} className="px-6 py-4">
                    {colIndex === columns - 4 ? (
                      <SkeletonLoader variant="badge" />
                    ) : (
                      <SkeletonLoader variant="text" width="120px" />
                    )}
                  </td>
                ))}
                <td className="px-6 py-4 text-right">
                  <SkeletonLoader variant="button" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="lg:hidden divide-y divide-border">
        {Array.from({ length: rows }, (_, index) => (
          <div key={index} className="p-4 space-y-3">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 flex-1">
                {showAvatar && <SkeletonLoader variant="avatar" />}
                <div className="space-y-2 flex-1">
                  <SkeletonLoader variant="text" width="70%" />
                  <SkeletonLoader variant="text" width="50%" />
                </div>
              </div>
              <SkeletonLoader variant="badge" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <SkeletonLoader variant="text" width="100%" />
              <SkeletonLoader variant="text" width="100%" />
            </div>
            <SkeletonLoader variant="button" width="100%" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;